// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"13d258482c4fa76e6d1d","123":"e3960c5ee989137a4fa5","124":"6d508d8297ffe5e8a23c","171":"1e3c4eb13cfd7ed4ef59"}[chunkId] + ".chunk.js";
};